import { render } from "./ReLoginPage.vue?vue&type=template&id=7e48d0c2&ts=true"
import script from "./ReLoginPage.vue?vue&type=script&lang=ts"
export * from "./ReLoginPage.vue?vue&type=script&lang=ts"

import "./ReLoginPage.vue?vue&type=style&index=0&id=7e48d0c2&lang=scss"

import exportComponent from "/Volumes/DATA/Project/WebsiteProject/Zalo_YHCT/ZaloOA_CLS_FE/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__